module.exports = __webpack_public_path__ + "e74242bf6e651d696355dfeb44330d76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/26.jpg
// module id = 1353
// module chunks = 47